<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import { useLessonPrivileges } from '../../model/lessons/lesson-privileges.hook'
import LessonFormLayout from './LessonFormLayout.vue'
import LessonConnection from './LessonConnection.vue'
import LessonFeedback from './LessonFeedback.vue'

defineOptions({
  name: 'LessonInfo',
})

/** Connection status is for lesson managers only, as its legacy tab was; without it the feedback has the card alone. */
const { canManageBookings } = useLessonPrivileges()
</script>

<template>
  <CardAdmin
    title="Lesson info"
    class="lesson-info"
    fullwidth
  >
    <LessonFormLayout v-if="canManageBookings">
      <template #main>
        <LessonConnection />
      </template>
      <template #aside>
        <LessonFeedback />
      </template>
    </LessonFormLayout>
    <div
      v-else
      class="lesson-info__single"
    >
      <LessonFeedback />
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./LessonInfo.scss" />
